export default __webpack_public_path__ + "static/media/stampLogo.dca11108.png";